export const evaluationTemplatesV1 = {
    BasicSpeaking: {
        label: "Basic Speaking",
        items: [
            {
                key: "relevance",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "contentRelevance",
                        label: "Sự liên quan về nội dung",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời câu hỏi hoặc trả lời hoàn toàn không liên quan đến nội dung của câu hỏi.", score: 0 },
                            { comment: "Học sinh chỉ đưa ra một phần thông tin liên quan đến câu hỏi mà không đầy đủ.", score: 1 },
                            { comment: "Học sinh trả lời đúng nội dung câu hỏi.", score: 2 }
                        ],
                    },
                    {
                        key: "answerStructure",
                        label: "Cấu trúc câu trả lời",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời câu hỏi.", score: 0 },
                            { comment: "Học sinh có trả lời được câu hỏi nhưng chưa đưa ra được các ý bổ trợ.", score: 1 },
                            { comment: "Học sinh trả lời được câu hỏi, cùng với một vài ý bổ trợ cho câu trả lời.", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "completeness",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationAmount",
                        label: "Lượng thông tin được đưa ra",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có thông tin nào được cung cấp", score: 0 },
                            { comment: "Cung cấp được một phần thông tin, nhưng chưa đủ để trả lời được câu hỏi", score: 1 },
                            { comment: "Cung cấp thông tin cần thiết đủ để trả lời câu hỏi", score: 2 }
                        ]
                    },
                    {
                        key: "vocabGrammarVariety",
                        label: "Sự đa dạng của từ vựng và ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có từ vựng hay ngữ pháp nào được cung cấp", score: 0 },
                            { comment: "Từ vựng và ngữ pháp còn lặp lại rất nhiều", score: 1 },
                            { comment: "Đã cố gắng sử dụng từ vựng và ngữ pháp đa dạng, tuy nhiên đôi khi chưa hiệu quả", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "fluency",
                label: "Độ trôi chảy",
                items: [
                    {
                        key: "easeOfUnderstanding",
                        label: "Khả năng nói liền mạch",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không nói được chút nào", score: 0 },
                            { comment: "Học sinh nói hầu như câu nào cũng vấp và thiếu liền mạch", score: 1 },
                            { comment: "Học sinh có thể nói liền mạch đa phần các câu, đôi khi có thể bị vấp hoặc ngập ngừng", score: 2 }
                        ]
                    },
                    {
                        key: "logicalArrangement",
                        label: "Sự kết nối giữa các ý",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không nói được gì nên không có sự kết nối giữa các ý", score: 0 },
                            { comment: "Học sinh có trả lời được, nhưng sự kết nối giữa các ý là rất ít.", score: 1 },
                            { comment: "Học sinh có thể hiện được sự kết nối giữa các ý tưởng, dù có thể chưa rõ ràng hoàn toàn.", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "clarity",
                label: "Sự rõ ràng",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Mức độ dễ hiểu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được hoặc câu trả lời không thể hiểu được", score: 0 },
                            { comment: "Học sinh trả lời có thể hiểu được, nhưng nhiều khi gây hiểu nhầm", score: 1 },
                            { comment: "Học sinh trả lời dễ hiểu và ít gặp trở ngại để hiểu được câu trả lời", score: 2 }
                        ]
                    },
                    {
                        key: "vocabAccuracy",
                        label: "Khả năng sắp xếp logic",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được hoặc câu trả lời hoàn toàn không logic một chút nào", score: 0 },
                            { comment: "Học sinh trả lời với những lập luận chưa được logic, tuy nhiên vẫn có sự kết nối nhất định giữa các ý", score: 1 },
                            { comment: "Học sinh trả lời với lập luận khá logic, dễ hiểu, không tạo cảm giác vô lý cho người nghe", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "accuracy",
                label: "Sự chính xác",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ chính xác về ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được, hoặc sai ngữ pháp gây hoàn toàn không hiểu được bài nói", score: 0 },
                            { comment: "Học sinh mắc khá nhiều lỗi ngữ pháp ở mỗi câu, nhưng không ảnh hưởng nhiều đến khả năng hiểu.", score: 1 },
                            { comment: "Học sinh có thể nói nhiều câu không mắc lỗi ngữ pháp, chỉ mắc một lượng lỗi không đáng kể và không ảnh hưởng đến khả năng hiểu", score: 2 }
                        ]
                    },
                    {
                        key: "vocabAccuracy",
                        label: "Độ chính xác về từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được, hoặc sử dụng từ vựng sai hết", score: 0 },
                            { comment: "Học sinh mắc nhiều lỗi về từ vựng", score: 1 },
                            { comment: "Học sinh có mắc một số lỗi về từ vựng nhưng không nhiều", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            }
        ]
    },
    BasicWriting: {
        label: "Basic Writing",
        items: [
            {
                key: "relevance",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "taskRelevance",
                        label: "Mức độ bám sát đề bài",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không trả lời câu hỏi hoặc nội dung hoàn toàn không liên quan", score: 0 },
                            { comment: "Có một vài chi tiết liên quan nhưng chưa đủ rõ ràng hoặc đi lạc hướng", score: 1 },
                            { comment: "Trả lời bám sát nội dung câu hỏi, thể hiện hiểu đúng đề", score: 2 }
                        ]
                    },
                    {
                        key: "taskAchievement",
                        label: "Trả lời đúng yêu cầu bài viết",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có phản hồi phù hợp (chỉ lặp lại đề bài hoặc viết các câu không mang thông tin cần thiết)", score: 0 },
                            { comment: "Có câu trả lời nhưng còn rất sơ sài hoặc quá ngắn (ví dụ: chỉ 1 câu đơn, không rõ ràng)", score: 1 },
                            { comment: "Trả lời có nội dung rõ ràng, có thể chứa 1–3 câu đơn có thông tin cụ thể và liên quan.", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "completeness",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationAmount",
                        label: "Lượng thông tin được đưa ra",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có ý nào rõ ràng hoặc chỉ viết lại từ đề bài", score: 0 },
                            { comment: "Có đưa ra 1–2 ý nhưng còn thiếu thông tin để hiểu rõ câu trả lời", score: 1 },
                            { comment: "Có ít nhất 2 ý cụ thể giúp làm rõ câu trả lời.", score: 2 }
                        ]
                    },
                    {
                        key: "lexicalAndGrammaticalVariety",
                        label: "Sự đa dạng của từ vựng và ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Gần như không viết được 1 câu đầy đủ nào", score: 0 },
                            { comment: "Có viết được những câu đầy đủ khác nhau nhưng vẫn lặp lại từ vựng và cấu trúc", score: 1 },
                            { comment: "Có sử dụng từ/cấu trúc khác nhau nhưng còn giới hạn và nhiều lặp lại", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "cohere",
                label: "Mạch lạc",
                items: [
                    {
                        key: "ideaOrganization",
                        label: "Sự sắp xếp các ý trong đoạn",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Các câu rời rạc, không liên quan đến nhau (thể hiện dấu hiệu lạc đề) hoặc không có logic về thứ tự", score: 0 },
                            { comment: "Có một số ý được sắp xếp theo trình tự nhưng đôi khi còn gây nhầm lẫn hoặc chưa mạch lạc", score: 1 },
                            { comment: "Các câu được viết theo trình tự hợp lý, dễ theo dõi, thể hiện mạch ý đơn giản", score: 2 }
                        ]
                    },
                    {
                        key: "cohesionAndLinking",
                        label: "Từ nối, sự liên kết giữa các câu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có bất kỳ từ nối nào hoặc dùng sai khiến đoạn rối", score: 0 },
                            { comment: "Có sử dụng từ nối đơn giản (and, but, because...) nhưng chưa nhất quán hoặc chưa đúng", score: 1 },
                            { comment: "Dùng từ nối phù hợp để liên kết các ý đơn giản. ", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "clarity",
                label: "Sự rõ ràng",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Mức độ dễ hiểu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Câu viết không hiểu được hoặc gây hiểu sai hoàn toàn", score: 0 },
                            { comment: "Câu có thể hiểu được nhưng cần đoán ý, hoặc gây hiểu nhầm ở một số chỗ", score: 1 },
                            { comment: "Câu diễn đạt rõ ràng, dễ hiểu, người đọc không cần suy đoán nhiều để nắm được ý", score: 2 }
                        ]
                    },
                    {
                        key: "ideaExpression",
                        label: "Diễn đạt ý",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Câu lủng củng, dùng từ sai ngữ cảnh khiến ý nghĩa không thể hiểu được", score: 0 },
                            { comment: "Câu có thể hiểu nhưng dùng từ chưa chính xác hoặc diễn đạt còn chung chung", score: 1 },
                            { comment: "Dùng từ đơn giản nhưng đúng ngữ cảnh, diễn đạt ý một cách hợp lý, dễ hình dung", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "accuracy",
                label: "Sự chính xác",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ chính xác về ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Tất cả các câu đều sai ngữ pháp, khiến người đọc không hiểu hoặc hiểu sai", score: 0 },
                            { comment: "Có nhiều lỗi ngữ pháp (chia thì, cấu trúc câu…) nhưng nhìn chung vẫn hiểu được ý", score: 1 },
                            { comment: "Phần lớn các câu đúng ngữ pháp đơn giản (S + V + O...), chỉ có vài lỗi nhỏ không ảnh hưởng đến việc hiểu", score: 2 }
                        ]
                    },
                    {
                        key: "vocabAccuracy",
                        label: "Độ chính xác về từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Dùng từ sai nghĩa, sai dạng từ hoặc không phù hợp với ngữ cảnh dẫn đến gây hiểu nhầm ý nghĩa cả bài", score: 0 },
                            { comment: "Có nhiều lỗi dùng từ nhưng ý nghĩa chung vẫn nắm được", score: 1 },
                            { comment: "Từ vựng đơn giản nhưng phù hợp ngữ cảnh, đúng nghĩa, ít lỗi", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            }
        ]
    },
    PiSpeaking: {
        label: "PI Speaking",
        items: [
            {
                key: "relevance",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "contentRelevance",
                        label: "Sự liên quan về nội dung",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời câu hỏi hoặc trả lời hoàn toàn không liên quan đến nội dung của câu hỏi.", score: 0 },
                            { comment: "Học sinh chỉ đưa ra một phần thông tin liên quan đến câu hỏi mà không đầy đủ", score: 1 },
                            { comment: "Học sinh trả lời đúng nội dung câu hỏi", score: 2 }
                        ]
                    },
                    {
                        key: "answerStructure",
                        label: "Cấu trúc câu trả lời",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời câu hỏi.", score: 0 },
                            { comment: "Học sinh có trả lời được câu hỏi nhưng chỉ đưa ra được khá ít các ý bổ trợ", score: 1 },
                            { comment: "Học sinh trả lời được câu hỏi, cùng với đầy đủ các ý bổ trợ cho câu trả lời.", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "completeness",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationProvided",
                        label: "Lượng thông tin được đưa ra",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có thông tin nào được cung cấp", score: 0 },
                            { comment: "Cung cấp được một phần thông tin, nhưng chưa đủ để trả lời được câu hỏi", score: 1 },
                            { comment: "Cung cấp thông tin cần thiết đủ để trả lời câu hỏi", score: 2 }
                        ]
                    },
                    {
                        key: "lexicalAndGrammaticalVariety",
                        label: "Sự đa dạng của từ vựng và ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có từ vựng hay ngữ pháp nào được cung cấp", score: 0 },
                            { comment: "Từ vựng và ngữ pháp còn lặp lại rất nhiều, hoặc có cố gắng sử dụng đa dạng nhưng chưa hiệu quả", score: 1 },
                            { comment: "Sử dụng từ vựng và ngữ pháp khá đa dạng và tương đối hiệu quả, nhưng vẫn còn nhiều lỗi khi sử dụng", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "fluency",
                label: "Độ trôi chảy",
                items: [
                    {
                        key: "speechFluency",
                        label: "Khả năng nói liền mạch",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không nói được chút nào", score: 0 },
                            { comment: "Học sinh nói hầu như câu nào cũng vấp và thiếu liền mạch", score: 1 },
                            { comment: "Học sinh có thể nói liền mạch đa phần các câu, đôi khi có thể bị vấp hoặc ngập ngừng", score: 2 }
                        ]
                    },
                    {
                        key: "ideaConnection",
                        label: "Sự kết nối giữa các ý",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không nói được gì nên không có sự kết nối giữa các ý", score: 0 },
                            { comment: "Học sinh có thể hiện được sự kết nối giữa các ý tưởng, dù có thể chưa rõ ràng hoàn toàn.", score: 1 },
                            { comment: "Học sinh trả lời với các ý được liên kết với nhau tương đối rõ ràng.", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "clarity",
                label: "Sự rõ ràng",
                items: [
                    {
                        key: "comprehensibility",
                        label: "Mức độ dễ hiểu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được hoặc câu trả lời không thể hiểu được", score: 0 },
                            { comment: "Học sinh trả lời có thể hiểu được, nhưng nhiều khi gây hiểu nhầm", score: 1 },
                            { comment: "Học sinh trả lời dễ hiểu và ít gặp trở ngại để hiểu được câu trả lời", score: 2 }
                        ]
                    },
                    {
                        key: "logicalOrganization",
                        label: "Khả năng sắp xếp logic",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được hoặc câu trả lời hoàn toàn không logic một chút nào", score: 0 },
                            { comment: "Học sinh trả lời với những lập luận chưa được logic, tuy nhiên vẫn có sự kết nối nhất định giữa các ý", score: 1 },
                            { comment: "Học sinh trả lời với lập luận khá logic, dễ hiểu, không tạo cảm giác vô lý cho người nghe", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "accuracy",
                label: "Sự chính xác",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ chính xác về ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được, hoặc sai ngữ pháp gây hoàn toàn không hiểu được bài nói", score: 0 },
                            { comment: "Học sinh mắc khá nhiều lỗi ngữ pháp ở mỗi câu, nhưng không ảnh hưởng nhiều đến khả năng hiểu.", score: 1 },
                            { comment: "Học sinh có thể nói nhiều câu không mắc lỗi ngữ pháp, chỉ mắc một lượng lỗi không đáng kể và không ảnh hưởng đến khả năng hiểu", score: 2 }
                        ]
                    },
                    {
                        key: "vocabularyAccuracy",
                        label: "Độ chính xác về từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học sinh không trả lời được, hoặc sử dụng từ vựng sai hết", score: 0 },
                            { comment: "Học sinh mắc nhiều lỗi về từ vựng", score: 1 },
                            { comment: "Học sinh có mắc một số lỗi về từ vựng nhưng không nhiều", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
        ],
    },
    PiWriting: {
        label: "PI Writing",
        items: [
            {
                key: "relevance",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "taskRelevance",
                        label: "Mức độ bám sát đề bài",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không trả lời đúng yêu cầu của đề, nội dung hoàn toàn không liên quan", score: 0 },
                            { comment: "Có một vài chi tiết liên quan đến đề nhưng chưa rõ ràng hoặc có chỗ lạc đề", score: 1 },
                            { comment: "Trả lời đúng trọng tâm, nội dung bám sát đề bài, thể hiện hiểu rõ yêu cầu chủ đề", score: 2 }
                        ]
                    },
                    {
                        key: "taskAchievement",
                        label: "Trả lời đúng yêu cầu bài viết",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Chỉ sao chép từ đề bài, viết các câu đơn không liên kết hoặc thông tin không cần thiết", score: 0 },
                            { comment: "Viết được một đoạn ngắn nhưng thông tin còn rời rạc, chưa bao phủ toàn bộ yêu cầu hoặc thiếu chiều sâu", score: 1 },
                            { comment: "Viết được đoạn văn đơn giản (4–6 câu hoặc hơn), thông tin rõ ràng, có sự bao quát phần lớn yêu cầu của đề bài", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "completeness",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationProvided",
                        label: "Lượng thông tin được đưa ra",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Chỉ viết lại đề bài hoặc viết vài từ/câu rất ngắn không chứa thông tin cụ thể", score: 0 },
                            { comment: "Đoạn có từ 2–3 câu mang ý nghĩa rõ ràng nhưng còn thiếu thông tin bổ trợ hoặc mô tả chưa đầy đủ", score: 1 },
                            { comment: "Đoạn có khoảng 4–6 câu tối thiểu, trình bày được ít nhất 2 ý chính cùng với lý do, ví dụ hoặc mô tả bổ sung đơn giản", score: 2 }
                        ]
                    },
                    {
                        key: "lexicalAndGrammaticalVariety",
                        label: "Sự đa dạng của từ vựng và ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Gần như chỉ lặp lại một vài từ và cấu trúc rất đơn giản.", score: 0 },
                            { comment: "Có sử dụng được một vài cấu trúc và từ vựng khác nhau, nhưng lặp lại đáng kể và thiếu linh hoạt.", score: 1 },
                            { comment: "Cố gắng sử dụng một số từ/cụm từ và cấu trúc câu khác nhau để làm phong phú nội dung, dù đôi lúc chưa chính xác", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "cohere",
                label: "Mạch lạc",
                items: [
                    {
                        key: "ideaOrganization",
                        label: "Sự sắp xếp các ý trong đoạn",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Các câu rời rạc, không liên quan đến nhau hoặc thứ tự ý gây nhầm lẫn, khiến người đọc khó theo dõi", score: 0 },
                            { comment: "Có tổ chức nhất định, các ý sắp xếp tương đối hợp lý nhưng chưa mượt hoặc đôi chỗ thiếu rõ ràng", score: 1 },
                            { comment: "Các ý được sắp xếp hợp lý, logic, dễ hiểu và mạch lạc", score: 2 }
                        ]
                    },
                    {
                        key: "cohesionAndLinking",
                        label: "Từ nối, sự liên kết giữa các câu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không có từ nối hoặc dùng từ nối sai gây cản trở mạch văn", score: 0 },
                            { comment: "Sử dụng từ nối cơ bản (and, but, because, then...) nhưng còn lặp lại hoặc dùng chưa đúng chỗ", score: 1 },
                            { comment: "Dùng đa dạng và hợp lý các từ nối để kết nối các câu và ý", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "clarity",
                label: "Sự rõ ràng",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Mức độ dễ hiểu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Câu văn lủng củng hoặc sai ngữ pháp đến mức gây hiểu sai hoặc không thể hiểu", score: 0 },
                            { comment: "Câu văn có thể hiểu được nhưng một số phần gây lúng túng hoặc phải đoán ý", score: 1 },
                            { comment: "Hầu hết các câu đều dễ hiểu, diễn đạt rõ ràng, người đọc nắm được nội dung mà không cần suy đoán.", score: 2 }
                        ]
                    },
                    {
                        key: "ideaExpression",
                        label: "Diễn đạt ý",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Câu diễn đạt không đúng ngữ cảnh, từ dùng sai hoặc diễn đạt mơ hồ khiến câu mất ý nghĩa", score: 0 },
                            { comment: "Câu có ý nhưng diễn đạt còn chung chung hoặc dùng từ chưa thật phù hợp", score: 1 },
                            { comment: "Câu diễn đạt mạch lạc, sử dụng từ đơn giản nhưng đúng ngữ cảnh và giúp hình dung rõ ràng nội dung", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "accuracy",
                label: "Độ chính xác",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ chính xác về ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Hầu hết các câu sai ngữ pháp nghiêm trọng (chia thì sai, sai cấu trúc, câu không hoàn chỉnh), gây hiểu sai", score: 0 },
                            { comment: "Có nhiều lỗi ngữ pháp (thiếu chủ ngữ, động từ, sai thì...) nhưng người đọc vẫn hiểu được phần lớn nội dung", score: 1 },
                            { comment: "Câu đơn và câu ghép đơn giản phần lớn đúng ngữ pháp, chỉ mắc lỗi nhỏ không ảnh hưởng đến khả năng hiểu", score: 2 }
                        ]
                    },
                    {
                        key: "vocabularyAccuracy",
                        label: "Độ chính xác về từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Dùng từ sai nghĩa, sai dạng, hoặc không phù hợp khiến câu bị hiểu sai hoặc mất nghĩa", score: 0 },
                            { comment: "Có một số lỗi dùng từ (sai collocation, dùng từ sai tình huống) nhưng không ảnh hưởng nghiêm trọng đến hiểu ý", score: 1 },
                            { comment: "Từ vựng phù hợp ngữ cảnh, dùng đúng từ/cụm từ thông dụng, có thể đơn giản nhưng rõ nghĩa", score: 2 }
                        ]
                    }
                ],
                comment_detail: "",
            },
        ]
    },
    FoundationSpeaking: {
        label: "Foundation Speaking",
        items: [
            {
                key: "fluencyAndCoherence",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "continuousSpeakingAbility",
                        label: "Khả năng nói liên tục",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Nói ngắt quãng thường xuyên, không thể hiện ý tưởng được một cách liên tục", score: 0.5 },
                            { comment: "Có thể nói liên tục nhưng vẫn gặp khó khăn, ngắt quãng hoặc do dự nhiều", score: 1.5 },
                            { comment: "Nói tương đối liên tục, ít ngắt quãng, nhưng chưa thực sự trôi chảy", score: 2.5 }
                        ]
                    },
                    {
                        key: "abilityArrangeIdeas",
                        label: "Khả năng sắp xếp ý tưởng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Ý tưởng rời rạc, không có sự liên kết hoặc không rõ ràng", score: 0.5 },
                            { comment: "Ý tưởng có sự liên kết nhưng đôi khi còn lộn xộn hoặc khó hiểu", score: 1.5 },
                            { comment: "Ý tưởng được sắp xếp mạch lạc, dễ hiểu nhưng vẫn còn đơn giản", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "lexicalResource",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationProvided",
                        label: "Sự đa dạng từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Sử dụng từ vựng hạn chế, lặp lại nhiều", score: 0.5 },
                            { comment: "Sử dụng từ vựng cơ bản, nhưng có thể thiếu sự đa dạng và một số lỗi", score: 1.5 },
                            { comment: "Sử dụng từ vựng đa dạng, phù hợp với chủ đề, nhưng chưa phong phú", score: 2.5 }
                        ]
                    },
                    {
                        key: "lexicalAndGrammaticalVariety",
                        label: "Sự chính xác và phù hợp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Từ vựng không chính xác hoặc không phù hợp với ngữ cảnh", score: 0.5 },
                            { comment: "Từ vựng sử dụng khá chính xác, phù hợp với ngữ cảnh, nhưng đôi khi còn mắc lỗi nhỏ", score: 1.5 },
                            { comment: "Từ vựng chính xác, phù hợp với ngữ cảnh và chủ đề, nhưng vẫn có thể còn một số lỗi nhỏ", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "Pronunciation",
                label: "Phát âm",
                items: [
                    {
                        key: "clarityAccuracy",
                        label: "Sự rõ ràng và chính xác",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Phát âm không rõ ràng, khó nghe, mắc nhiều lỗi", score: 0.5 },
                            { comment: "Phát âm tương đối rõ ràng, nhưng vẫn còn một số lỗi phát âm", score: 1.5 },
                            { comment: "Phát âm rõ ràng, dễ hiểu, nhưng có thể chưa đạt đến mức hoàn hảo", score: 2.5 }
                        ]
                    },
                    {
                        key: "abilityIntonationNegative",
                        label: "Khả năng sử dụng ngữ điệu và trọng âm",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Ngữ điệu đơn điệu, trọng âm không chính xác", score: 0.5 },
                            { comment: "Sử dụng ngữ điệu và trọng âm cơ bản, nhưng đôi khi chưa tự nhiên", score: 1.5 },
                            { comment: "Ngữ điệu và trọng âm sử dụng khá tự nhiên, nhưng vẫn còn đơn giản hoặc chưa nhất quán", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "grammaticalRangeAccuracy",
                label: "Ngữ pháp và độ chính xác",
                items: [
                    {
                        key: "abilityVarietyOfStructures",
                        label: "Khả năng sử dụng đa dạng cấu trúc",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Cấu trúc câu rất đơn giản, lặp lại, không đa dạng", score: 0.5 },
                            { comment: "Sử dụng một số cấu trúc ngữ pháp đa dạng, nhưng còn hạn chế", score: 1.5 },
                            { comment: "Sử dụng đa dạng cấu trúc ngữ pháp, nhưng vẫn còn thiếu phức tạp", score: 2.5 }
                        ]
                    },
                    {
                        key: "accuracy",
                        label: "Sự chính xác",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Nhiều lỗi ngữ pháp ảnh hưởng đến khả năng hiểu câu trả lời", score: 0.5 },
                            { comment: "Một số lỗi ngữ pháp nhỏ nhưng không ảnh hưởng lớn đến khả năng hiểu câu trả lời", score: 1.5 },
                            { comment: "Ngữ pháp chính xác với một số lỗi nhỏ, nhưng không ảnh hưởng đến khả năng hiểu câu trả lời", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
        ]
    },
    FoundationWriting: {
        label: "Foundation Writing",
        items: [
            {
                key: "taskAchievement",
                label: "Trả lời đúng yêu cầu bài viết",
                items: [
                    {
                        key: "levelSatisfactionMeetings",
                        label: "Mức độ đáp ứng yêu cầu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Không thể hiện được gì", score: 0.5 },
                            { comment: "Trả lời được một phần câu hỏi, nhưng chưa đầy đủ", score: 1.5 },
                            { comment: "Hoàn toàn đáp ứng yêu cầu câu hỏi, nhưng có thể chưa xuất sắc", score: 2.5 }
                        ]
                    },
                    {
                        key: "clarityPersuasion",
                        label: "Tính rõ ràng và sự thuyết phục",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Ý tưởng mơ hồ, không rõ ràng hoặc thiếu thuyết phục", score: 0.5 },
                            { comment: "Ý tưởng cơ bản rõ ràng, nhưng thiếu thuyết phục hoặc hỗ trợ cụ thể", score: 1.5 },
                            { comment: "Ý tưởng rõ ràng, có tính thuyết phục, được hỗ trợ bởi ví dụ, lập luận cụ thể", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "lexicalResource",
                label: "Độ hoàn thiện",
                items: [
                    {
                        key: "informationProvided",
                        label: "Sự đa dạng từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Sử dụng từ vựng hạn chế, lặp lại nhiều", score: 0.5 },
                            { comment: "Từ vựng ở mức cơ bản, có một số lỗi lặp từ", score: 1.5 },
                            { comment: "Sử dụng từ vựng đa dạng, tránh lặp từ, nhưng chưa phong phú", score: 2.5 }
                        ]
                    },
                    {
                        key: "lexicalAndGrammaticalVariety",
                        label: "Sự chính xác và phù hợp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Từ vựng không chính xác hoặc không phù hợp với ngữ cảnh", score: 0.5 },
                            { comment: "Sử dụng từ vựng phù hợp với một số lỗi nhỏ", score: 1.5 },
                            { comment: "Từ vựng chính xác, phù hợp với ngữ cảnh và chủ đề", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "coherenceCohesion",
                label: "Sự gắn kết",
                items: [
                    {
                        key: "abilityArrangeIdeas",
                        label: "Khả năng sắp xếp các ý tưởng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Ý tưởng sắp xếp lộn xộn, không rõ ràng", score: 0.5 },
                            { comment: "Ý tưởng sắp xếp hợp lý nhưng có thể chưa mạch lạc", score: 1.5 },
                            { comment: "Ý tưởng được sắp xếp mạch lạc và có sự logic nhất định", score: 2.5 }
                        ]
                    },
                    {
                        key: "abilityWords",
                        label: "Khả năng sử dụng từ nối",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Ít hoặc không sử dụng từ nối, câu rời rạc", score: 0.5 },
                            { comment: "Sử dụng từ nối cơ bản nhưng chưa linh hoạt", score: 1.5 },
                            { comment: "Sử dụng từ nối hiệu quả để liên kết các ý tưởng, dù chưa đa dạng", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "grammaticalRangeAccuracy",
                label: "Ngữ pháp và độ chính xác",
                items: [
                    {
                        key: "diversity",
                        label: "Sự đa dạng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Sử dụng rất hạn chế các cấu trúc ngữ pháp", score: 0.5 },
                            { comment: "Sử dụng một số cấu trúc cơ bản, nhưng thiếu đa dạng", score: 1.5 },
                            { comment: "Sử dụng đa dạng các cấu trúc ngữ pháp, dù còn đơn giản", score: 2.5 }
                        ]
                    },
                    {
                        key: "accuracy",
                        label: "Sự chính xác",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Lỗi ngữ pháp nhiều, ảnh hưởng đến khả năng hiểu bài viết", score: 0.5 },
                            { comment: "Một số lỗi ngữ pháp nhưng không ảnh hưởng nhiều đến khả năng hiểu bài viết", score: 1.5 },
                            { comment: "Ngữ pháp tương đối chính xác, nhưng còn mắc một số lỗi nhỏ", score: 2.5 }
                        ]
                    }
                ],
                comment_detail: "",
            },
        ]
    },
    IEHighSpeaking: {
        label: "IE High Speaking",
        items: [
            {
                key: "fluencyCoherence",
                label: "Độ trôi chảy và mạch lạc",
                items: [
                    {
                        key: "expandAndDevelop",
                        label: "Mở rộng và phát triển ý",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng mở rộng ý tưởng một cách tự nhiên và sâu sắc. <br/>" +
                                    "Học viên sử dụng một loạt các cấu trúc ngữ pháp và từ vựng phong phú, linh hoạt để trình bày ý kiến, và có khả năng diễn đạt ý tưởng phức tạp một cách rõ ràng và logic",
                                score: 9
                            },
                            { comment: "Học viên có khả năng phát triển ý tưởng tốt và linh hoạt, dùng ngôn ngữ một cách chính xác và sáng tạo. <br/>" +
                                    "Học viên biểu đạt ý kiến một cách rõ ràng và có thể sử dụng một số cấu trúc ngữ pháp và từ vựng phức tạp",
                                score: 8
                            },
                            { comment: "Học viên có khả năng mở rộng ý tưởng khá tốt, nhưng có thể thiếu sự linh hoạt trong việc sử dụng ngôn ngữ. <br/>" +
                                    "Học viên có thể diễn đạt ý kiến một cách rõ ràng, nhưng không sử dụng một loạt cấu trúc ngữ pháp và từ vựng đa dạng",
                                score: 7
                            },
                            { comment: "Học viên có khả năng mở rộng ý tưởng nhưng không liên kết chặt chẽ, thường lặp lại ý tưởng hoặc thông tin. <br/>" +
                                    "Học viên sử dụng ngôn ngữ một cách cơ bản và không sáng tạo, có thể gặp khó khăn trong việc diễn đạt ý kiến",
                                score: 6
                            },
                            { comment: "Học viên có khả năng mở rộng ý tưởng hạn chế và không có sự phát triển rõ ràng. <br/>" +
                                    "Học viên có thể sử dụng ngôn ngữ cơ bản và không biểu đạt ý kiến một cách chính xác",
                                score: 5
                            },
                            { comment: "Học viên có khả năng mở rộng ý tưởng rất hạn chế và không có sự phát triển rõ ràng. <br/>" +
                                    "Học viên sử dụng ngôn ngữ cơ bản và không thể diễn đạt ý kiến một cách chính xác",
                                score: 4
                            },
                            { comment: "Học viên không có khả năng mở rộng ý tưởng, thường sử dụng ngôn ngữ cơ bản và không thể diễn đạt ý kiến một cách rõ ràng hoặc logic", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "breakHesitate",
                        label: "Ngắt nghỉ và ngập ngừng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng nói liền mạch một cách tự nhiên và mượt mà, không có ngắt nghỉ hoặc ngập ngừng đáng kể, nếu có thì đều có chủ đích. <br/>" +
                                    "Học viên duy trì luồng nói một cách mạch lạc và dễ dàng theo dõi, thể hiện sự chính xác và tự tin trong diễn đạt",
                                score: 9
                            },
                            { comment: "Học viên có khả năng nói liền mạch một cách khá tự nhiên, mặc dù có thể có một số ngắt nghỉ nhỏ hoặc ngập ngừng không đáng kể. Tuy nhiên, điều này không ảnh hưởng nhiều đến khả năng của Học viên trong việc truyền đạt ý kiến", score: 8 },
                            { comment: "Học viên có khả năng duy trì luồng nói tương đối liền mạch, mặc dù đôi khi có thể có một số ngắt nghỉ và ngập ngừng. Sự ngắt nghỉ này không gây ra sự rối loạn lớn trong luồng ý tưởng", score: 7 },
                            { comment: "Học viên có khả năng duy trì luồng nói ở mức trung bình. <br/>" +
                                    "Học viên có thể gặp một số ngắt nghỉ và ngập ngừng trong khi nói, điều này có thể làm mất đi sự mạch lạc của bài nói của Học viên",
                                score: 6
                            },
                            { comment: "Học viên có khả năng duy trì luồng nói hạn chế và thường xuyên gặp ngắt nghỉ và ngập ngừng. Sự gián đoạn này có thể làm mất đi sự rõ ràng và dễ hiểu của bài nói", score: 5 },
                            { comment: "Học viên có khả năng duy trì luồng nói rất hạn chế, thường xuyên gặp ngắt nghỉ và ngập ngừng lớn, làm mất đi tính mạch lạc và dễ hiểu của bài nói", score: 4 },
                            { comment: "Học viên gặp rất nhiều khó khăn trong việc duy trì luồng nói liền mạch, thường có nhiều ngắt nghỉ và ngập ngừng, khiến bài nói trở nên rất khó hiểu và mất tính chính xác", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "speakingSpeed",
                        label: "Tốc độ nói",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng duy trì tốc độ nói lý tưởng, phù hợp với bài nói và người nghe. <br/>" +
                                    "Học viên điều chỉnh tốc độ nói một cách linh hoạt để phù hợp với các ý tưởng phức tạp và biểu đạt một cách rõ ràng và tự tin",
                                score: 9
                            },
                            { comment: "Học viên có khả năng duy trì tốc độ nói khá tốt. <br/>" +
                                    "Học viên điều chỉnh tốc độ để phù hợp với nội dung và người nghe, mặc dù có thể có một số chỗ ngắt quãng hoặc tăng tốc độ không đều",
                                score: 8
                            },
                            { comment: "Học viên có khả năng duy trì tốc độ nói tương đối ổn định. Tuy nhiên, có thể có một số chỗ ngắt quãng hoặc chậm lại, điều này có thể làm mất đi sự mạch lạc trong bài nói", score: 7 },
                            { comment: "Học viên có khả năng duy trì tốc độ nói ở mức trung bình. <br/>" +
                                    "Học viên có thể có sự thay đổi đột ngột trong tốc độ nói, làm mất đi tính liên tục và mạch lạc của bài nói",
                                score: 6
                            },
                            { comment: "Học viên có khả năng duy trì tốc độ nói rất hạn chế, thường có sự thay đổi đột ngột trong tốc độ nói, làm mất đi tính liên tục và dễ hiểu của bài nói", score: 5 },
                            { comment: "Học viên có khả năng duy trì luồng nói rất hạn chế, thường xuyên gặp ngắt nghỉ và ngập ngừng lớn, làm mất đi tính mạch lạc và dễ hiểu của bài nói", score: 4 },
                            { comment: "Học viên không có khả năng duy trì tốc độ nói ổn định, thường có sự thay đổi đột ngột và không đều, khiến bài nói trở nên rất khó hiểu và mất tính chính xác", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "phrasesLeadConnect",
                        label: "Sử dụng các cụm từ để mở đầu, dẫn dắt, kết nối",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng các cụm từ mở đầu và kết nối một cách tự nhiên và linh hoạt. <br/>" +
                                    "Học viên có khả năng sử dụng một loạt các cấu trúc cụm từ phong phú và đa dạng để mở đầu bài nói, dẫn dắt ý tưởng và liên kết các phần trong bài nói một cách mạch lạc và hợp lý",
                                score: 9
                            },
                            { comment: "Học viên sử dụng các cụm từ mở đầu và kết nối một cách linh hoạt và khéo léo. <br/>" +
                                    "Học viên có khả năng sử dụng một số cấu trúc cụm từ để mở đầu, dẫn dắt ý tưởng và kết nối các phần trong bài nói một cách hợp lý, tuy nhiên không đến mức hoàn hảo",
                                score: 8
                            },
                            { comment: "Học viên có khả năng sử dụng các cụm từ mở đầu và kết nối tương đối tốt. <br/>" +
                                    "Học viên sử dụng một số cấu trúc cụm từ để mở đầu và liên kết ý tưởng trong bài nói, mặc dù có thể có sự thiếu đồng nhất và linh hoạt trong việc sử dụng chúng",
                                score: 7
                            },
                            { comment: "Học viên sử dụng các cụm từ mở đầu và kết nối ở mức trung bình. <br/>" +
                                    "Học viên có thể sử dụng một số cấu trúc cụm từ để mở đầu và kết nối ý tưởng, nhưng thường có sự lặp lại và thiếu đồng nhất trong việc sử dụng chúng",
                                score: 6
                            },
                            { comment: "Học viên có khả năng sử dụng các cụm từ mở đầu và kết nối hạn chế. <br/>" +
                                    "Học viên sử dụng ít cấu trúc cụm từ để mở đầu và kết nối ý tưởng, dẫn đến sự gián đoạn và thiếu mạch lạc trong bài nói của Học viên",
                                score: 5
                            },
                            { comment: "Học viên sử dụng các cụm từ mở đầu và kết nối rất hạn chế. <br/>" +
                                    "Học viên có thể thiếu cơ bản các cấu trúc cụm từ để mở đầu và kết nối ý tưởng, dẫn đến bài nói trở nên rời rạc và khó hiểu",
                                score: 4
                            },
                            { comment: "Học viên không có khả năng sử dụng các cụm từ mở đầu và kết nối, dẫn đến bài nói trở nên rất khó hiểu và không có mạch lạc", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "ideaOrganization",
                        label: "Độ mạch lạc",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng diễn đạt mạch lạc, logic và mượt mà. <br/>" +
                                    "Học viên có khả năng sử dụng các liên kết logic giữa các ý tưởng, câu và đoạn văn một cách xuất sắc, tạo ra một bài nói tự nhiên và dễ hiểu",
                                score: 9
                            },
                            { comment: "Học viên có khả năng diễn đạt mạch lạc và logic. <br/>" +
                                    "Học viên sử dụng các liên kết rõ ràng giữa các ý tưởng và thông tin, mặc dù có thể có một số gián đoạn nhỏ hoặc sự lặp lại trong việc diễn đạt",
                                score: 8
                            },
                            { comment: "Học viên có khả năng diễn đạt mạch lạc nhưng có thể có một số gián đoạn hoặc sự thiếu liên kết giữa các ý tưởng. <br/>" +
                                    "Học viên có khả năng sử dụng liên kết nhưng không liên tục",
                                score: 7
                            },
                            { comment: "Học viên có khả năng diễn đạt mạch lạc ở mức trung bình. <br/>" +
                                    "Học viên có thể có nhiều gián đoạn hoặc sự thiếu liên kết giữa các ý tưởng, dẫn đến sự lặp lại hoặc thiếu logic trong bài nói của Học viên. <br/>" +
                                    "Bài nói của Học viên có thể bị gián đoạn và khó hiểu",
                                score: 6
                            },
                            { comment: "Học viên có khả năng diễn đạt mạch lạc hạn chế và không có sự liên kết rõ ràng giữa các ý tưởng", score: 5 },
                            { comment: "Học viên có khả năng diễn đạt mạch lạc rất hạn chế, thường có nhiều gián đoạn và thiếu liên kết rõ ràng giữa các ý tưởng", score: 4 },
                            { comment: "Học viên không có khả năng diễn đạt mạch lạc, có nhiều gián đoạn và thiếu liên kết, dẫn đến việc bài nói trở nên rất khó hiểu", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                ],
                comment_detail: "",
            },
            {
                key: "lexicalResource",
                label: "Vốn từ vựng",
                items: [
                    {
                        key: "varietyOfVocabulary",
                        label: "Độ đa dạng của từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng sử dụng từ vựng rộng rãi và linh hoạt. <br/>" +
                                    "Học viên biết cách sử dụng từ ngữ chính xác, phức tạp và đa dạng để truyền đạt ý kiến một cách chính xác và sáng tạo",
                                score: 9
                            },
                            { comment: "Học viên có khả năng sử dụng từ vựng khá đa dạng và linh hoạt. <br/>" +
                                    "Học viên sử dụng từ ngữ chính xác và phong phú để biểu đạt ý kiến, mặc dù có thể không như sáng tạo và phức tạp như ở band điểm 9",
                                score: 8
                            },
                            { comment: "Học viên có khả năng sử dụng từ vựng tương đối đa dạng và phong phú. <br/>" +
                                    "Học viên sử dụng từ ngữ chính xác để diễn đạt ý kiến, tuy nhiên, có thể thiếu tính linh hoạt và sự sáng tạo trong việc sử dụng từ vựng",
                                score: 7
                            },
                            { comment: "Học viên có khả năng sử dụng từ vựng ở mức trung bình. <br/>" +
                                    "Học viên sử dụng từ ngữ cơ bản và không đa dạng, có thể lặp lại từ ngữ hoặc sử dụng từ vựng không phù hợp trong một số trường hợp",
                                score: 6
                            },
                            { comment: "Học viên có khả năng sử dụng từ vựng hạn chế và cơ bản. <br/>" +
                                    "Học viên sử dụng từ ngữ cơ bản để trình bày ý kiến, có thể gặp khó khăn trong việc biểu đạt ý tưởng phức tạp",
                                score: 5
                            },
                            { comment: "Học viên có khả năng sử dụng từ vựng rất hạn chế và cơ bản. <br/>" +
                                    "Học viên có thể sử dụng từ ngữ không chính xác hoặc không phù hợp, gây ra sự không rõ ràng và không chính xác trong việc diễn đạt ý kiến",
                                score: 4
                            },
                            { comment: "Học viên không có khả năng sử dụng từ vựng cơ bản, gây ra sự không rõ ràng và không hiểu rõ ý kiến của Học viên. Sử dụng từ ngữ không chính xác và không phù hợp là phổ biến", score: 3 },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "accuracyVocabulary",
                        label: "Độ chính xác trong sử dụng từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng từ vựng rất chính xác và phong phú. <br/>" +
                                    "Học viên chọn từ ngữ phù hợp với ngữ cảnh và biểu đạt ý kiến một cách chính xác, không gây hiểu lầm. Sự linh hoạt và sáng tạo trong việc sử dụng từ vựng cũng là điểm mạnh của Học viên",
                                score: 9
                            },
                            { comment: "Học viên sử dụng từ vựng khá chính xác và phong phú. <br/>" +
                                    "Học viên chọn từ ngữ phù hợp với ngữ cảnh và biểu đạt ý kiến một cách rõ ràng, ít gây hiểu lầm. Mặc dù có thể không như sáng tạo như ở band điểm cao hơn, nhưng vẫn đạt được mức độ linh hoạt",
                                score: 8
                            },
                            { comment: "Học viên sử dụng từ vựng tương đối chính xác và phù hợp với ngữ cảnh. <br/>" +
                                    "Học viên có khả năng chọn từ ngữ tương đối chính xác để diễn đạt ý kiến, mặc dù có thể gặp một số hiểu lầm nhỏ hoặc sự lặp lại trong việc sử dụng từ vựn",
                                score: 7
                            },
                            { comment: "Học viên sử dụng từ vựng ở mức trung bình. <br/>" +
                                    "Học viên sử dụng từ ngữ cơ bản và phù hợp để trình bày ý kiến, tuy nhiên có thể gặp một số lỗi hoặc sự lặp lại trong từ vựng", score: 6
                            },
                            { comment: "Học viên sử dụng từ vựng hạn chế và thường gặp nhiều lỗi trong việc chọn từ hoặc sử dụng từ không phù hợp với ngữ cảnh, gây hiểu lầm cho người nghe", score: 5 },
                            { comment: "Học viên sử dụng từ vựng rất hạn chế và thường gặp nhiều lỗi trong việc chọn từ hoặc sử dụng từ không phù hợp, gây ra sự không rõ ràng và không chính xác trong diễn đạt. <br/>" +
                                    "Học viên có thể sử dụng từ ngữ không chính xác hoặc không phù hợp, gây ra sự không rõ ràng và không chính xác trong việc diễn đạt ý kiến",
                                score: 4
                            },
                            { comment: "Học viên thường gặp rất nhiều khó khăn trong việc sử dụng từ vựng. <br/>" +
                                    "Lỗi trong việc chọn từ hoặc sử dụng từ không phù hợp là phổ biến, và điều này gây hiểu lầm và không chính xác khi truyền đạt ý kiến",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "paraphrasing",
                        label: "Paraphrasing",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng paraphrase rất tốt và linh hoạt. <br/>" +
                                    "Học viên biết cách tái diễn ý tưởng một cách sáng tạo và chính xác, sử dụng từ vựng và cấu trúc câu khác nhau một cách linh hoạt và tự nhiên",
                                score: 9
                            },
                            { comment: "Học viên có khả năng paraphrase khá tốt. <br/>" +
                                    "Học viên thường tái diễn ý tưởng một cách chính xác và linh hoạt, dùng từ vựng và cấu trúc câu khác nhau để biểu đạt ý kiến một cách rõ ràng",
                                score: 8
                            },
                            { comment: "Học viên có khả năng paraphrase tương đối tốt. <br/>" +
                                    "Học viên có khả năng tái diễn ý tưởng với một mức độ chính xác và linh hoạt, dù có thể thiếu tính sáng tạo trong việc sử dụng từ ngữ",
                                score: 7
                            },
                            { comment: "Học viên có khả năng paraphrase ở mức trung bình. <br/>" +
                                    "Học viên có thể tái diễn ý tưởng nhưng thường sử dụng từ vựng và cấu trúc câu gần giống nhau, không có nhiều sự linh hoạt",
                                score: 6
                            },
                            { comment: "Học viên có khả năng paraphrase hạn chế. <br/>" +
                                    "Học viên có thể tái diễn ý tưởng nhưng thường thiếu sự linh hoạt và chính xác trong việc sử dụng từ ngữ, dẫn đến sự lặp lại",
                                score: 5
                            },
                            { comment: "Học viên có khả năng paraphrase rất hạn chế. <br/>" +
                                    "Học viên thường không thể tái diễn ý tưởng một cách chính xác hoặc linh hoạt, và có thể dẫn đến sự hiểu lầm",
                                score: 4
                            },
                            { comment: "Học viên không có khả năng paraphrase. <br/>" +
                                    "Sự tái diễn ý tưởng thường không chính xác hoặc không linh hoạt, dẫn đến sự hiểu lầm và không rõ ràng trong diễn đạt",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "pronunciation",
                label: "Phát âm",
                items: [
                    {
                        key: "pronunciationAbility",
                        label: "Khả năng phát âm",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng phát âm rất chính xác và tự nhiên. <br/>" +
                                    "Học viên phát âm các âm thanh, từ ngữ và câu văn một cách rõ ràng và dễ hiểu, không gặp lỗi phát âm nào đáng kể",
                                score: 9
                            },
                            { comment: "Học viên có khả năng phát âm khá chính xác và tự nhiên. <br/>" +
                                    "Học viên thường phát âm các âm thanh và từ ngữ một cách rõ ràng và dễ hiểu, mặc dù có thể gặp một số lỗi nhỏ không ảnh hưởng nhiều đến sự hiểu rõ",
                                score: 8
                            },
                            { comment: "Học viên có khả năng phát âm tương đối chính xác. <br/>" +
                                    "Học viên có khả năng phát âm các âm thanh và từ ngữ với sự rõ ràng và dễ hiểu, mặc dù có thể gặp một số lỗi nhỏ hoặc có thể cần sự cải thiện để làm rõ hơn",
                                score: 7
                            },
                            { comment: "Học viên có khả năng phát âm ở mức trung bình. <br/>" +
                                    "Học viên có thể phát âm các âm thanh và từ ngữ một cách tương đối rõ ràng, nhưng thường gặp nhiều lỗi phát âm nhỏ, có thể làm mất đi sự dễ hiểu",
                                score: 6
                            },
                            { comment: "Học viên có khả năng phát âm hạn chế. <br/>" +
                                    "Học viên thường gặp nhiều lỗi phát âm, làm mất đi tính rõ ràng và dễ hiểu của bài nói",
                                score: 5
                            },
                            { comment: "Học viên có khả năng phát âm rất hạn chế. <br/>" +
                                    "Học viên gặp nhiều lỗi phát âm và có thể không dễ hiểu cho người nghe",
                                score: 4
                            },
                            { comment: "Học viên thường có khả năng phát âm kém. <br/>" +
                                    "Lỗi phát âm xuất hiện thường xuyên và làm mất đi sự rõ ràng và hiểu rõ ý kiến của Học viên",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "gravity",
                        label: "Trọng âm",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ rất chính xác và tự nhiên. <br/>" +
                                    "Học viên hiểu và áp dụng quy tắc về trọng âm một cách linh hoạt và chính xác, khiến cho bài nói của Học viên trở nên dễ hiểu và tự nhiên",
                                score: 9
                            },
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ khá chính xác. <br/>" +
                                    "Học viên thường áp dụng đúng quy tắc về trọng âm và làm cho các từ trở nên rõ ràng và dễ hiểu, mặc dù có thể gặp một số trường hợp không nhấn trọng âm hoàn toàn chính xác",
                                score: 8
                            },
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ tương đối chính xác. <br/>" +
                                    "Học viên thường áp dụng quy tắc về trọng âm và làm cho các từ trở nên tương đối rõ ràng và dễ hiểu, mặc dù có thể có một số từ không được nhấn trọng âm chính xác",
                                score: 7
                            },
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ ở mức trung bình. <br/>" +
                                    "Học viên có thể nhấn trọng âm cho các từ một cách tương đối đúng, nhưng có thể gặp khó khăn trong việc duy trì tính chính xác và nhất quán",
                                score: 6
                            },
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ hạn chế. <br/>" +
                                    "Học viên có thể không nhấn trọng âm đúng đắn cho một số từ, gây ra sự không rõ ràng và khó hiểu",
                                score: 5
                            },
                            { comment: "Học viên có khả năng nhấn trọng âm cho các từ rất hạn chế. <br/>" +
                                    "Học viên thường không nhấn trọng âm đúng đắn, gây ra sự mất đi tính rõ ràng và dễ hiểu của bài nói",
                                score: 4
                            },
                            { comment: "Học viên thường không có khả năng nhấn trọng âm. <br/>" +
                                    "Sự không nhấn trọng âm đúng đắn gây ra sự mất tính rõ ràng và không hiểu rõ ý kiến của Học viên",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "intonation",
                        label: "Ngữ điệu",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng sử dụng ngữ điệu một cách rất linh hoạt và tự nhiên. <br/>" +
                                    "Học viên biết cách thay đổi âm điệu một cách chính xác để truyền đạt ý nghĩa, cảm xúc và sự nhấn mạnh trong bài nói của mình",
                                score: 9
                            },
                            { comment: "Học viên có khả năng sử dụng ngữ điệu khá linh hoạt và tự nhiên. <br/>" +
                                    "Học viên thường sử dụng ngữ điệu một cách rõ ràng để thể hiện ý nghĩa và cảm xúc trong bài nói, mặc dù có thể không như linh hoạt và sâu sắc như ở band điểm 9",
                                score: 8
                            },
                            { comment: "Học viên có khả năng sử dụng ngữ điệu tương đối linh hoạt. <br/>" +
                                    "Học viên có khả năng thay đổi âm điệu để diễn đạt ý nghĩa và cảm xúc, mặc dù có thể không nhất quán hoặc không sâu sắc",
                                score: 7
                            },
                            { comment: "Học viên có khả năng sử dụng ngữ điệu ở mức trung bình. <br/>" +
                                    "Học viên có thể thay đổi âm điệu nhưng thường không nhất quán hoặc không chính xác, làm giảm tính rõ ràng của bài nói",
                                score: 6
                            },
                            { comment: "Học viên có khả năng sử dụng ngữ điệu hạn chế. <br/>" +
                                    "Học viên có thể không thay đổi âm điệu một cách hiệu quả, dẫn đến sự mất đi tính rõ ràng và không đầy đủ của ý nghĩa cần truyền đạt",
                                score: 5
                            },
                            { comment: "Học viên có khả năng sử dụng ngữ điệu rất hạn chế. <br/>" +
                                    "Học viên thường không thể thay đổi âm điệu một cách chính xác, làm giảm tính rõ ràng và cảm xúc của bài nói",
                                score: 4
                            },
                            { comment: "Học viên thường không có khả năng sử dụng ngữ điệu. <br/>" +
                                    "Sự không sử dụng ngữ điệu gây ra sự mất tính rõ ràng và không hiểu rõ ý nghĩa cần truyền đạt",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "span",
                        label: "Nhịp nói",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có khả năng duy trì nhịp điệu một cách rất tự nhiên và linh hoạt. <br/>" +
                                    "Học viên giữ được nhịp điệu câu chữ một cách chính xác và thích hợp, tạo ra một luồng nói rõ ràng và dễ nghe",
                                score: 9
                            },
                            { comment: "Học viên có khả năng duy trì nhịp điệu khá tự nhiên và linh hoạt. <br/>" +
                                    "Học viên thường duy trì một nhịp điệu chính xác, làm cho luồng nói trở nên dễ hiểu và truyền đạt ý nghĩa tốt",
                                score: 8
                            },
                            { comment: "Học viên có khả năng duy trì nhịp điệu tương đối tự nhiên. <br/>" +
                                    "Học viên có thể duy trì nhịp điệu một cách đáng tin cậy, mặc dù có thể không nhất quán hoặc không linh hoạt hoàn toàn",
                                score: 7
                            },
                            { comment: "Học viên có khả năng duy trì nhịp điệu ở mức trung bình. <br/>" +
                                    "Học viên có thể duy trì nhịp điệu tương đối chính xác, nhưng thường không nhất quán hoặc có thể bị gián đoạn",
                                score: 6
                            },
                            { comment: "Học viên có khả năng duy trì nhịp điệu hạn chế. <br/>" +
                                    "Học viên có thể gặp khó khăn trong việc duy trì một nhịp điệu chính xác và thường bị gián đoạn trong luồng nói",
                                score: 5
                            },
                            { comment: "Học viên có khả năng duy trì nhịp điệu rất hạn chế. <br/>" +
                                    "Học viên thường không duy trì được nhịp điệu chính xác, gây ra sự mất đi tính liên tục và dễ nghe của bài nói",
                                score: 4
                            },
                            { comment: "Học viên thường không có khả năng duy trì nhịp điệu. <br/>" +
                                    "Sự không duy trì được nhịp điệu chính xác gây ra sự mất đi tính liên tục và không dễ nghe",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "grammaticalRangeAccuracy",
                label: "Sự chính xác",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ đa dạng của ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp rất đa dạng và phong phú. <br/>" +
                                    "Học viên biết cách sử dụng cấu trúc ngữ pháp phức tạp và linh hoạt, đồng thời tránh được sự lặp lại và sử dụng một cách chính xác, tự nhiên",
                                score: 9
                            },
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp khá đa dạng và phong phú. <br/>" +
                                    "Học viên có khả năng sử dụng cấu trúc ngữ pháp phức tạp và linh hoạt, mặc dù có thể không như linh hoạt và sâu sắc như ở band điểm 9",
                                score: 8
                            },
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp tương đối đa dạng. <br/>" +
                                    "Học viên có khả năng sử dụng một loạt các cấu trúc ngữ pháp, mặc dù có thể không nhất quán hoặc không sử dụng một cách linh hoạt",
                                score: 7
                            },
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp ở mức trung bình. <br/>" +
                                    "Học viên có thể sử dụng một số cấu trúc ngữ pháp khá phổ biến một cách đúng đắn, nhưng thường không đa dạng và có thể gặp lặp lại",
                                score: 6
                            },
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp hạn chế. <br/>" +
                                    "Học viên có thể sử dụng một số cấu trúc ngữ pháp cơ bản, nhưng thường không linh hoạt và gặp khó khăn trong việc sử dụng một cách chính xác",
                                score: 5
                            },
                            { comment: "Học viên sử dụng các cấu trúc ngữ pháp rất hạn chế. <br/>" +
                                    "Học viên thường chỉ sử dụng một số cấu trúc ngữ pháp cơ bản và có thể gặp nhiều lỗi khi sử dụng chúng",
                                score: 4
                            },
                            { comment: "Học viên thường không sử dụng các cấu trúc ngữ pháp nào ngoài câu đơn. <br/>" +
                                    "Sự thiếu đa dạng và sử dụng cấu trúc ngữ pháp không đúng gây ra sự mất đi tính chính xác và rõ ràng của bài nói",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    },
                    {
                        key: "accuracyGrammar",
                        label: "Độ chính xác trong sử dụng ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có sự chính xác ngữ pháp rất cao. <br/>" +
                                    "Học viên sử dụng ngữ pháp một cách chính xác và linh hoạt trong nhiều tình huống khác nhau, hiểu rõ và sử dụng các cấu trúc ngữ pháp phức tạp một cách tự nhiên và không gặp lỗi nhiều",
                                score: 9 },
                            { comment: "Học viên có sự chính xác ngữ pháp khá cao. <br/>" +
                                    "Học viên thường sử dụng ngữ pháp một cách chính xác, nhưng có thể gặp một số lỗi nhỏ không ảnh hưởng nhiều đến sự hiểu rõ của thông điệp",
                                score: 8
                            },
                            { comment: "Học viên có sự chính xác ngữ pháp tương đối. <br/>" +
                                    "Học viên sử dụng ngữ pháp một cách chính xác trong phần lớn các trường hợp, nhưng có thể có một số lỗi không nghiêm trọng hoặc sử dụng ngữ pháp phức tạp không linh hoạt",
                                score: 7
                            },
                            { comment: "Học viên có sự chính xác ngữ pháp ở mức trung bình. <br/>" +
                                    "Học viên có thể sử dụng một số cấu trúc ngữ pháp cơ bản một cách đúng, nhưng thường gặp lỗi và có thể gây hiểu lầm",
                                score: 6
                            },
                            { comment: "Học viên có sự chính xác ngữ pháp hạn chế. <br/>" +
                                    "Học viên có thể sử dụng một số cấu trúc ngữ pháp cơ bản, nhưng thường gặp lỗi nhiều và gây ra sự không chính xác trong diễn đạt",
                                score: 5
                            },
                            { comment: "Học viên có sự chính xác ngữ pháp rất hạn chế. <br/>" +
                                    "Học viên thường gặp nhiều lỗi ngữ pháp cơ bản và có thể gây hiểu lầm trong thông điệp của Học viên",
                                score: 4
                            },
                            { comment: "Học viên thường không có sự chính xác ngữ pháp ở hầu hết các trường hợp. <br/>" +
                                    "Lỗi ngữ pháp xuất hiện thường xuyên và làm mất đi tính rõ ràng và đúng đắn của thông điệp",
                                score: 3
                            },
                            { comment: "Học viên không trả lời được đa phần các câu hỏi", score: 2 },
                            { comment: "Học viên không trả lời được câu hỏi nào", score: 1 },
                        ]
                    }
                ],
                comment_detail: "",
            },
        ]
    },
    IEHighWriting: {
        label: "IE High Writing",
        items: [
            {
                key: "taskAchievement",
                label: "Độ phù hợp",
                items: [
                    {
                        key: "followRequirementsOfProblem",
                        label: "Thực hiện yêu cầu của đề bài",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên hoàn thành nhiệm vụ xuất sắc. <br/>" +
                                    "Học viên trả lời đầy đủ và chi tiết các phần của đề bài, không chỉ đáp ứng các yêu cầu cơ bản mà còn phát triển ý kiến một cách sâu sắc, minh bạch và logic",
                                score: 9
                            },
                            { comment: "Học viên hoàn thành nhiệm vụ tốt. <br/>" +
                                    "Học viên trả lời đầy đủ các phần của đề bài và cung cấp ý kiến rõ ràng và logic, mặc dù có thể không chi tiết và sâu sắc như ở band điểm 9",
                                score: 8
                            },
                            { comment: "Học viên hoàn thành nhiệm vụ tương đối tốt. <br/>" +
                                    "Học viên trả lời nhiều phần của đề bài, mặc dù có thể thiếu chi tiết hoặc không được tổ chức hoàn hảo, nhưng ý kiến vẫn rõ ràng và logic",
                                score: 7
                            },
                            { comment: "Học viên hoàn thành nhiệm vụ ở mức trung bình. <br/>" +
                                    "Học viên trả lời một phần của đề bài, nhưng thường thiếu chi tiết và có thể không rõ ràng hoặc hơi lệch hướng so với đề bài <br/>" +
                                    "Sự chuyển đổi có thể không mượt mà",
                                score: 6
                            },
                            { comment: "Học viên hoàn thành nhiệm vụ rất hạn chế. <br/>" +
                                    "Học viên có thể không trả lời đầy đủ các phần của đề bài, thiếu chi tiết và logic, làm giảm tính toàn diện và hiệu quả của bài viết",
                                score: 5
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung rất hạn chế. <br/>" +
                                    "Học viên thường không trả lời đầy đủ yêu cầu cơ bản của đề bài, có thể đi lạc khỏi chủ đề hoặc không hiểu rõ yêu cầu",
                                score: 4
                            },
                            { comment: "Học viên thường không hoàn thành nhiệm vụ. <br/>" +
                                    "Bài viết của Học viên không đáp ứng yêu cầu của đề bài, không liên quan hoặc không hiểu rõ chủ đề, gây mất đi tính toàn vẹn và ý nghĩa của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    },
                    {
                        key: "argumentLogicOfArticle",
                        label: "Lập luận và tính logic của bài viết",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có lập luận rất rõ ràng và có logic. <br/>" +
                                    "Học viên phát triển các ý kiến một cách logic, minh bạch và liên kết, sử dụng các ví dụ và luận điểm phù hợp để minh chứng và bảo vệ quan điểm của Học viên",
                                score: 9
                            },
                            { comment: "Học viên có lập luận khá rõ ràng và có logic. <br/>" +
                                    "Học viên phát triển các ý kiến một cách rõ ràng và có cấu trúc logic, mặc dù có thể không chi tiết và sâu sắc như ở band điểm 9",
                                score: 8
                            },
                            { comment: "Học viên có lập luận tương đối rõ ràng và có logic. <br/>" +
                                    "Học viên cung cấp các ý kiến một cách hợp lý và có cấu trúc logic, mặc dù có thể không nhất quán hoặc không được minh bạch hoàn toàn",
                                score: 7
                            },
                            { comment: "Học viên có lập luận ở mức trung bình. <br/>" +
                                    "Học viên có thể cung cấp các ý kiến một cách tương đối logic, nhưng thường thiếu chi tiết và có thể không rõ ràng hoặc hơi lệch hướng so với chủ đề",
                                score: 6
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung hạn chế. <br/>" +
                                    "Bài viết của Học viên có thể không được tổ chức một cách rõ ràng và thiếu liên kết giữa các ý, làm giảm tính logic và rõ ràng của bài viết",
                                score: 5
                            },
                            { comment: "Học viên có lập luận rất hạn chế. <br/>" +
                                    "Học viên thường không cung cấp lập luận logic, có thể làm mất đi tính toàn diện và ý nghĩa của bài viết",
                                score: 4
                            },
                            { comment: "Học viên thường không có lập luận. <br/>" +
                                    "Lập luận của Học viên không rõ ràng, không logic và gây mất đi tính rõ ràng và đúng đắn của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "ideaOrganization",
                label: "Độ mạch lạc",
                items: [
                    {
                        key: "contentCoherence",
                        label: "Độ mạch lạc về mặt nội dung",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có sự mạch lạc về mặt nội dung xuất sắc. <br/>" +
                                    "Bài viết của họ được tổ chức một cách logic, với mỗi đoạn văn chứa ý chính rõ ràng và được kết nối chặt chẽ với các ý khác trong bài. <br/>" +
                                    "Sự chuyển đổi giữa các ý và đoạn văn diễn ra một cách mượt mà và tự nhiên",
                                score: 9
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung khá tốt. <br/>" +
                                    "Học viên tổ chức bài viết một cách logic và có cấu trúc, mặc dù có thể không chi tiết và liên kết sâu sắc như ở band điểm 9. <br/>" +
                                    "Sự kết nối giữa các ý vẫn rõ ràng và mượt mà",
                                score: 8
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung tương đối tốt <br/>" +
                                    "Bài viết của Học viên có sự liên kết và cấu trúc, mặc dù có thể thiếu tính nhất quán hoặc không rõ ràng <br/>" +
                                    "Sự chuyển đổi giữa các ý vẫn diễn ra một cách hợp lý",
                                score: 7
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung ở mức trung bình. <br/>" +
                                    "Bài viết của Học viên có thể tổ chức một cách tương đối logic, nhưng thường thiếu sự kết nối rõ ràng giữa các ý <br/>" +
                                    "Sự chuyển đổi có thể không mượt mà",
                                score: 6
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung hạn chế. <br/>" +
                                    "Bài viết của Học viên có thể không được tổ chức một cách rõ ràng và thiếu liên kết giữa các ý, làm giảm tính logic và rõ ràng của bài viết",
                                score: 5
                            },
                            { comment: "Học viên có sự mạch lạc về mặt nội dung rất hạn chế. <br/>" +
                                    "Bài viết của Học viên thường không có cấu trúc hoặc không có sự liên kết giữa các ý, gây ra sự không rõ ràng và lộn xộn", score: 4 },
                            { comment: "Học viên thường không có sự mạch lạc về mặt nội dung. <br/>" +
                                    "Sự thiếu liên kết và cấu trúc gây ra sự mất đi tính rõ ràng và ý nghĩa của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    },
                    {
                        key: "formalCoherence",
                        label: "Độ mạch lạc về mặt hình thức",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp một cách rất chính xác và linh hoạt để nối các ý kiến, câu và đoạn văn một cách mượt mà và logic. <br/>" +
                                    "Cách sắp xếp ý kiến giữa các câu và đoạn văn rất hợp lý và có sự liên kết chặt chẽ, tạo nên sự kết nối mạch lạc và logic",
                                score: 9
                            },
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp khá chính xác và linh hoạt để liên kết các ý kiến, câu và đoạn văn. <br/>" +
                                    "Mặc dù không chi tiết và liên kết sâu sắc như ở band điểm 9, nhưng sự chuyển đổi giữa các ý vẫn rõ ràng và mạch lạc",
                                score: 8
                            },
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp một cách tương đối chính xác và linh hoạt. <br/>" +
                                    "Sự chuyển đổi giữa các ý vẫn diễn ra một cách hợp lý, tạo nên một bài viết có sự liên kết tốt. <br/>" +
                                    "Bài viết có sự liên kết và cấu trúc khá hợp lý, mặc dù có thể thiếu tính nhất quán hoặc không rõ ràng",
                                score: 7
                            },
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp ở mức trung bình. <br/>" +
                                    "Bài viết có thể tổ chức một cách tương đối logic, nhưng thường thiếu sự kết nối rõ ràng giữa các ý <br/>" +
                                    "Sự chuyển đổi có thể không mượt mà", score: 6 },
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp hạn chế. <br/>" +
                                    "Bài viết có thể không được tổ chức một cách rõ ràng và thiếu liên kết giữa các ý, làm giảm tính logic và rõ ràng của bài viết",
                                score: 5
                            },
                            { comment: "Học viên sử dụng các từ nối và cấu trúc ngữ pháp rất hạn chế. <br/>" +
                                    "Bài viết thường không có cấu trúc hoặc không có sự liên kết giữa các ý, gây ra sự không rõ ràng và lộn xộn",
                                score: 4
                            },
                            { comment: "Học viên thường không sử dụng các từ nối và cấu trúc ngữ pháp cần thiết. <br/>" +
                                    "Sự thiếu liên kết và cấu trúc không rõ ràng gây khó khăn trong việc hiểu được ý nghĩa của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "lexicalResource",
                label: "Vốn từ vựng",
                items: [
                    {
                        key: "varietyOfVocabulary",
                        label: "Độ đa dạng của từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên có sử dụng một loạt các từ vựng rộng và phong phú. <br/>" +
                                    "Họ biết cách sử dụng từ ngữ chính xác, linh hoạt và đa dạng từ các lĩnh vực khác nhau, bao gồm từ vựng thông thường và chuyên ngành. <br/>" +
                                    "Sự đa dạng trong từ vựng tạo nên sự sâu sắc và mạch lạc trong ý kiến và ý tưởng",
                                score: 9
                            },
                            { comment: "Học viên có sử dụng từ vựng khá đa dạng. <br/>" +
                                    "Học viên sử dụng một loạt từ vựng rộng và linh hoạt từ các lĩnh vực khác nhau. <br/>" +
                                    "Mặc dù không chi tiết và phong phú như ở band điểm 9, nhưng sự đa dạng vẫn góp phần tạo ra tính sâu sắc trong bài viết",
                                score: 8
                            },
                            { comment: "Học viên có sử dụng từ vựng tương đối đa dạng. <br/>" +
                                    "ọc viên sử dụng một số từ vựng phong phú từ các lĩnh vực khác nhau, tuy nhiên, có thể thiếu sự linh hoạt trong việc sử dụng cụm từ hoặc từ vựng chuyên ngành",
                                score: 7
                            },
                            { comment: "Học viên có sử dụng từ vựng đa dạng ở mức trung bình. <br/>" +
                                    "Bài viết có thể có sự lặp lại từ ngữ hoặc thiếu sự linh hoạt trong việc sử dụng cụm từ hoặc từ vựng chuyên ngành, làm giảm tính phong phú và sâu sắc của ý tưởng",
                                score: 6
                            },
                            { comment: "Học viên sử dụng từ vựng kém đa dạng. Bài viết thường lặp lại từ ngữ và thiếu sự linh hoạt trong việc sử dụng cụm từ hoặc từ vựng chuyên ngành, làm giảm tính phong phú và đa dạng của ý tưởng", score: 5 },
                            { comment: "Học viên sử dụng từ vựng không đa dạng. <br/>" +
                                    "Bài viết thường không có sự đa dạng trong từ ngữ, gây ra sự nhàm chán và giảm tính hấp dẫn của ý tưởng",
                                score: 4
                            },
                            { comment: "Học viên thường không sử dụng được đa dạng từ vựng và hầu như chỉ lặp lại các từ cơ bản. <br/>" +
                                    "Sự thiếu đa dạng gây ra sự mất đi tính hấp dẫn và sâu sắc của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    },
                    {
                        key: "accuracyOfVocabulary",
                        label: "Độ chính xác của từ vựng",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng các từ vựng một cách chính xác và linh hoạt. <br/>" +
                                    "Học viên biết cách áp dụng từ ngữ đúng ngữ cảnh và không mắc lỗi về ý nghĩa hoặc cấu trúc câu. <br/>" +
                                    "Việc sử dụng từ vựng chính xác góp phần tạo nên sự chính xác và sâu sắc trong ý kiến và ý tưởng",
                                score: 9
                            },
                            { comment: "Học viên sử dụng từ vựng khá chính xác. <br/>" +
                                    "Học viên có khả năng sử dụng từ ngữ phù hợp và chính xác với ngữ cảnh, mặc dù có thể có một vài lỗi nhỏ hoặc sự lặp lại từ ngữ trong bài viết",
                                score: 8
                            },
                            { comment: "Học viên sử dụng từ vựng tương đối chính xác. <br/>" +
                                    "Học viên có khả năng sử dụng từ ngữ phù hợp, tuy nhiên, có thể xuất hiện một số lỗi nhỏ hoặc sự lặp lại từ ngữ không cần thiết trong bài viết",
                                score: 7
                            },
                            { comment: "Học viên sử dụng từ vựng ở mức trung bình. <br/>" +
                                    "Bài viết có thể có một số lỗi trong việc sử dụng từ ngữ hoặc không chính xác với ngữ cảnh, làm giảm tính chính xác và sâu sắc của ý tưởng",
                                score: 6
                            },
                            { comment: "Học viên sử dụng từ vựng khá thiếu chính xác. <br/>" +
                                    "Bài viết thường có nhiều lỗi về từ ngữ, gây ra sự mất đi tính chính xác của ý tưởng",
                                score: 5
                            },
                            { comment: "Học viên sử dụng từ vựng không chính xác. <br/>" +
                                    "Bài viết thường có nhiều lỗi về từ ngữ, khiến ý nghĩa trở nên mơ hồ và không chính xác",
                                score: 4
                            },
                            { comment: "Học viên thường sử dụng từ vựng không chính xác. <br/>" +
                                    "Sự thiếu chính xác gây ra sự mất đi tính rõ ràng và ý nghĩa của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    }
                ],
                comment_detail: "",
            },
            {
                key: "grammarAccuracy",
                label: "Độ đa dạng của ngữ pháp",
                items: [
                    {
                        key: "grammarAccuracy",
                        label: "Độ đa dạng của ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Thí sinh sử dụng một loạt các cấu trúc ngữ pháp linh hoạt và đa dạng. <br/>" +
                                    "Họ biết cách sử dụng các cấu trúc ngữ pháp phức tạp một cách linh hoạt và tự nhiên, không mắc lỗi nghiêm trọng. Sự linh hoạt trong ngữ pháp góp phần tạo ra sự đa dạng và sâu sắc trong ý kiến và ý tưởng.",
                                score: 9
                            },
                            { comment: "Học viên có sử dụng ngữ pháp khá đa dạng. <br/>" +
                                    "Học viên sử dụng một loạt các cấu trúc ngữ pháp phong phú và linh hoạt, mặc dù có thể có một vài lỗi nhỏ hoặc sự lặp lại cấu trúc trong bài viết.",
                                score: 8
                            },
                            { comment: "Học viên có sử dụng ngữ pháp tương đối đa dạng. <br/>" +
                                    "Học viên sử dụng một loạt các cấu trúc ngữ pháp từ cơ bản đến nâng cao, tuy nhiên, có thể xuất hiện một số lỗi nhỏ hoặc sự lặp lại cấu trúc không cần thiết trong bài viết.",
                                score: 7
                            },
                            { comment: "Học viên có sử dụng ngữ pháp ở mức trung bình. <br/>" +
                                    "Bài viết có thể có một số lỗi trong việc sử dụng ngữ pháp hoặc không chính xác với ngữ cảnh, làm giảm tính chính xác và sâu sắc của ý tưởng",
                                score: 6
                            },
                            { comment: "Học viên có sử dụng ngữ pháp đa dạng hạn chế. <br/>" +
                                    "Bài viết thường có nhiều lỗi về ngữ pháp, gây ra sự mất đi tính chính xác của ý tưởng",
                                score: 5
                            },
                            { comment: "Học viên sử dụng ngữ pháp không đa dạng. Bài viết thường không có sự đa dạng trong cấu trúc ngữ pháp, gây ra sự nhàm chán và giảm tính hấp dẫn của ý tưởng", score: 4 },
                            { comment: "Học viên có khả năng sử dụng ngữ pháp rất hạn chế. Sự thiếu đa dạng gây ra sự mất đi tính rõ ràng và ý nghĩa của bài viết", score: 3 },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    },
                    {
                        key: "accuracyOfGrammar",
                        label: "Độ chính xác của ngữ pháp",
                        comment_auto: "",
                        criterion_score: "",
                        items: [
                            { comment: "Học viên sử dụng ngữ pháp một cách chính xác và linh hoạ. <br/>" +
                                    "Học viên hiểu rõ các cấu trúc ngữ pháp và sử dụng chúng một cách tự nhiên, không mắc lỗi ngữ pháp nghiêm trọng. <br/>" +
                                    "Sự linh hoạt và chính xác trong ngữ pháp góp phần tạo ra sự rõ ràng và sâu sắc trong ý kiến và ý tưởng",
                                score: 9
                            },
                            { comment: "Học viên có sử dụng ngữ pháp khá chính xác. <br/>" +
                                    "Học viên sử dụng các cấu trúc ngữ pháp một cách chính xác và tự tin, mặc dù có thể có một vài lỗi nhỏ hoặc sự lặp lại cấu trúc trong bài viết",
                                score: 8
                            },
                            { comment: "Học viên có sử dụng ngữ pháp tương đối chính xác. <br/>" +
                                    "Học viên sử dụng một loạt các cấu trúc ngữ pháp từ cơ bản đến nâng cao, tuy nhiên, có thể xuất hiện một số lỗi nhỏ hoặc sự lặp lại cấu trúc không cần thiết trong bài viết",
                                score: 7
                            },
                            { comment: "Học viên có sử dụng ngữ pháp ở mức trung bình. <br/>" +
                                    "Bài viết có thể có một số lỗi trong việc sử dụng ngữ pháp hoặc không chính xác với ngữ cảnh, làm giảm tính chính xác và sâu sắc của ý tưởng",
                                score: 6
                            },
                            { comment: "Học viên có sử dụng ngữ pháp không thực sự chính xác. <br/>" +
                                    "Bài viết thường có nhiều lỗi về ngữ pháp, gây ra sự mất đi tính chính xác của ý tưởng",
                                score: 5
                            },
                            { comment: "Học viên sử dụng ngữ pháp không chính xác. <br/>" +
                                    "Bài viết thường không có sự chính xác trong cấu trúc ngữ pháp, gây ra sự nhàm chán và giảm tính hấp dẫn của ý tưởng",
                                score: 4
                            },
                            { comment: "Học viên thường sử dụng ngữ pháp không chính xác. <br/>" +
                                    "Sự thiếu chính xác gây ra sự mất đi tính rõ ràng và ý nghĩa của bài viết",
                                score: 3
                            },
                            { comment: "Học viên chưa hoàn thành phần lớn nội dung bài", score: 2 },
                            { comment: "Bài viết chưa đủ độ dài để đánh giá (dưới 30 từ)", score: 1 },
                            { comment: "Học viên không làm bài/ tham khảo bài viết từ nguồn khác", score: 0 }
                        ]
                    }
                ],
                comment_detail: "",
            },
        ]
    },
};

export const BASIC = 1621
export const PRE = 1622
export const IELTS3545 = 1623
export const IELTS4555 = 1624
export const IELTS5565 = 1625

export const SPEAKING = 1
export const WRITING = 2

export const BASIC_IELTS_ELITE      = 1694
export const PRE_IELTS_ELITE        = 1695
export const FOUNDATIONS_1VS1       = 1466
export const FOUNDATIONS_1VS6       = 1247
export const IELTS_3_5_4_5_ELITE    = 1696
export const IELTS_4_5_5_5_ELITE    = 1697
export const IELTS_5_5_6_5_ELITE    = 1698

export const BASIC_ELITE_ECOACH = 1708
export const PRE_ELITE_ECOACH = 1707
export const IELTS_3_5_ELITE_ECOACH = 1706
export const IELTS_4_5_ELITE_ECOACH = 1705
export const IELTS_5_5_ELITE_ECOACH = 16269


export const IELTS_6_5_7_5_ONLINE_IELTS = 1635;
export const IELTS_5_5_6_5_ONLINE_IELTS = 1634;
export const IELTS_4_5_5_5_ONLINE_IELTS = 1633;
export const IELTS_3_5_4_5_ONLINE_IELTS = 1632;
export const PRE_IELTS_ONLINE_IELTS     = 1631;
export const BASIC_IELTS_ONLINE_IELTS   = 1630;

